"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectItemFactoryFromJS = exports.ProjectItemFactory = void 0;
const immutable_1 = require("immutable");
exports.ProjectItemFactory = (0, immutable_1.Record)({
    id: null,
    name: null,
    status: null,
    fastApprove: null,
    hideApprovals: null,
    delegable: null,
    showParentHistory: null,
    secretKey: null,
    path: null,
    mobileFormView: null,
    createdAt: null,
    createBy: null,
    extension: null,
    packageVersion: null,
    minorVersion: null,
    currentSecretKey: null,
    currentVersion: null,
    hasPinCode: null,
    projectPath: null
});
const ProjectItemFactoryFromJS = function (data) {
    return (0, exports.ProjectItemFactory)(Object.assign({}, data));
};
exports.ProjectItemFactoryFromJS = ProjectItemFactoryFromJS;
//# sourceMappingURL=IProjectIem.js.map